import Button from "../../design-system/components/Button/Button.jsx";
import { styles } from "../not-found/notFoundPage.css";

/**
 * Generic error state shown when a data load throws something other than a 404.
 * The retry button resets the nearest `RouteBoundary`, which triggers SWR to
 * revalidate the failed request.
 */
const ErrorState = ({ onRetry }: { onRetry?: () => void }) => (
  <div className={styles.container}>
    <p className={styles.text}>
      Hier ist leider etwas schiefgelaufen. Bitte versuche es noch einmal.
    </p>
    {onRetry && (
      <Button width="fit" onClick={onRetry}>
        Erneut versuchen
      </Button>
    )}
  </div>
);

export default ErrorState;
